import {Component, Fragment} from "react";
import * as React from "react";
import CreateTeamSiteCard, {CreateSiteCardProps} from "./CreateTeamSiteCard";
import {Icon, TextField} from "office-ui-fabric-react";
import {MegaMenuItemSelector, MegaMenuOption} from "./MegaMenuItemSelector";
import CreateSiteForm, {CreateSiteFormGroup, GroupAccessLevel} from "../models/CreateSiteForm";
import GroupSelector, {IGroupOption} from "./GroupSelector";
import * as _ from "lodash";
import CommunicationSiteTemplateSelector from "./CommunicationSiteTemplateSelector";


interface GroupOptions {
    
    [key: string] : IGroupOption[];
    
    read: IGroupOption[];
    edit: IGroupOption[];
    design: IGroupOption[];
    fullControl: IGroupOption[];
}

interface CreateCommunicationSiteCardState {
    form: CreateSiteForm;
    selectedOptions: GroupOptions
}

export default class CreateCommunicationSiteCard extends Component<CreateSiteCardProps,CreateCommunicationSiteCardState>
{
    private static formGroupsToGroupOptions(formGroups: CreateSiteFormGroup[]): GroupOptions 
    {
        return {
            read: formGroups.filter(g => g.access === "read").map(g => GroupSelector.createSiteFormGroupToGroupOption(g)),
            edit: formGroups.filter(g => g.access === "edit").map(g => GroupSelector.createSiteFormGroupToGroupOption(g)),
            design: formGroups.filter(g => g.access === "design").map(g => GroupSelector.createSiteFormGroupToGroupOption(g)),
            fullControl: formGroups.filter(g => g.access === "full control").map(g => GroupSelector.createSiteFormGroupToGroupOption(g)),
        };
    }
    
    private static groupOptionsToFormGroups(groupOptions: GroupOptions): CreateSiteFormGroup[]
    {
        const read = groupOptions.read.map(go => this.groupOptionToFormGroup(go,"read"));
        const edit = groupOptions.edit.map(go => this.groupOptionToFormGroup(go,"edit"));
        const design = groupOptions.design.map(go => this.groupOptionToFormGroup(go,"design"));
        const fullControl = groupOptions.fullControl.map(go => this.groupOptionToFormGroup(go,"full control"));
        
        return [...read,...edit,...design,...fullControl];
    }
    
    private static groupOptionToFormGroup(groupOption: IGroupOption,access: GroupAccessLevel): CreateSiteFormGroup
    {
        return {
            groupId: groupOption.id as string,
            groupDisplayName: groupOption.text as string,
            access: access,
        }
    }
    
    constructor(props: Readonly<CreateSiteCardProps>) {
        super(props);
        
        const selectedOptions = CreateCommunicationSiteCard.formGroupsToGroupOptions(props.form.groups);

        //DO NOT REMOVE - Setting this stops empty onchange triggering on first input
        props.form.siteName = "";
        this.state = {
          form: props.form,
          selectedOptions  
        };
    }
    
    async componentDidMount(): Promise<void> {
    }


    componentDidUpdate(prevProps: Readonly<CreateSiteCardProps>, prevState: Readonly<CreateCommunicationSiteCardState>, snapshot?: any): void
    {
        if(this.props.form !== prevProps.form)
        {
            const selectedOptions = CreateCommunicationSiteCard.formGroupsToGroupOptions(this.props.form.groups);
            this.setState({
                form: this.props.form,
                selectedOptions
            });
        }
        
        if(this.state.selectedOptions !== prevState.selectedOptions)
        {
            this.state.form.groups = CreateCommunicationSiteCard.groupOptionsToFormGroups(this.state.selectedOptions);;
            this.setState({
                form: this.state.form
            });
        }
    }
    
    private buildGroupSelectorRow(access: string): JSX.Element
    {
        return (
            <Fragment>
                <div className={"create-site-card__row"}>
                    <GroupSelector
                        tenantId={this.props.tenantId}
                        className={"flex-item--flex-1"}
                        disabled={this.props.disabled}
                        multiSelect={true}
                        label={`${_.capitalize(_.lowerCase(access))} Groups`}
                        selectedOptions={this.state.selectedOptions[access]}
                        onSelectionChanged={(selectedGroups: IGroupOption[]) => {

                            const selectedOptions = _.clone(this.state.selectedOptions) as GroupOptions;
                            selectedOptions[access] = selectedGroups;
                            this.setState({
                                selectedOptions
                            });
                        }}/>
                </div>      
            </Fragment>
        );
    }
    

    public render() {

        let selectedMegaMenuOption: MegaMenuOption | undefined = this.state.form.menuSiteUrl ? { listName: this.state.form.menuListName!, sitePathForList: this.state.form.siteName! } : undefined;
        
        return (
            <div className="create-site-card">

                <div className={"card__header"}>
                    <Icon iconName="SharePointLogo" className={"p-left-1rem"}/>
                    {CreateTeamSiteCard.buildCardTitle(this.state.form)}
                    {this.props.children}
                </div>

                <div className={"card__content"}>
                    <div className={"create-site-card__row"}>

                        <TextField
                            className="flex-item--flex-1 m-right-1rem"
                            disabled={this.props.disabled}
                            label="Site Name"
                            value={this.state.form.siteName}
                            required
                            onChange={(siteName: any) => {
                                this.state.form.siteName = siteName.target.value;
                                this.setState({
                                    form: this.state.form
                                });
                            }}
                        />

                        <CommunicationSiteTemplateSelector
                            tenantId={this.props.tenantId}
                            schoolCode={this.props.schoolCode}
                            className="m-right-1rem"
                            selectedTemplateName={this.state.form.communicationTemplate}
                            disabled={this.props.disabled} onChanged={(template) => {
                                this.state.form.communicationTemplate = template;
                                this.setState({
                                    form: this.state.form
                                });
                            }} />

                        <MegaMenuItemSelector
                            megaMenuOptions={this.props.megaMenuOptions}
                            disabled={this.props.disabled}
                            selectedMegamenuOption={selectedMegaMenuOption}
                            onSelectionChanged={(megaMenuOption: MegaMenuOption) => {
                                this.state.form.menuListName = megaMenuOption.listName;
                                this.state.form.menuSiteUrl = megaMenuOption.sitePathForList;
    
                                this.setState({
                                    form: this.state.form
                                });
                            }
                        }/>
                    </div>
                    
                    {this.buildGroupSelectorRow("read")}
                    {this.buildGroupSelectorRow("edit")}
                    {this.buildGroupSelectorRow("design")}
                    {this.buildGroupSelectorRow("fullControl")}
                    
                </div>

            </div>
        );
    }
}